import storage from "store";
import {jdLogin} from '../api/login'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import {browserFlag} from '@/utils/BrowserUtil'

export const myMixins = {
  components: {},
  data() {
    return {}
  },
  created() {
    const token = storage.get(ACCESS_TOKEN)
    this.token = token
    if (!token) {
      // 区分h5和pc的跳转
      if (browserFlag() || this.$route.query.type|| this.$route.query.jc) {
        this.login()
      } else {
        this.$router.replace('/login')
      }
    }
  },
  methods: {
    login() {
      if (this.$route.query.code) {
        let data = {}
        data.code = this.$route.query.code
        data.redirectUri = this.delParam('code')
        jdLogin(data).then(res => {
          if (res.code === 10000) {
            storage.set(ACCESS_TOKEN, res.result.jwtToken)
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const type =  urlParams.get('type');
            // 区分h5和pc的跳转
            if (browserFlag()) {
              if (type &&  type == 1){
                this.$router.replace({path: '/educationalTraining-h5'})
              }else {
                location.replace('/')
              }
            } else {
              if (type &&  type == 1){
                this.$router.replace({path: '/educationalTraining-pc'}).then(() => {
                  this.$router.go(0);  // 强制刷新页面
                });
              }  if (type &&  type == 2){
                this.$router.replace({path: '/venueDetail-pc'}).then(() => {
                  this.$router.go(0);  // 强制刷新页面
                });
              }else {
                this.$router.replace({ path: '/activity-pc' }).then(() => {
                  this.$router.go(0);  // 强制刷新页面
                });
              }

            }
          }
        })
      } else {
        window.location.href = 'https://jaccount.sjtu.edu.cn/oauth2/authorize?response_type=code&client_id=S3odi52qVYxBNTEh2qiD&redirect_uri=' + window.location.href
      }
    },
    // 删除url中某个参数,并跳转
    delParam(paramKey) {
      let url = window.location.href;    //页面url
      let urlParam = window.location.search.substr(1);   //页面参数
      let beforeUrl = url.substr(0, url.indexOf("?"));   //页面主地址（参数之前地址）
      let nextUrl = "";

      let arr = new Array();
      if (urlParam != "") {
        let urlParamArr = urlParam.split("&"); //将参数按照&符分成数组
        for (let i = 0; i < urlParamArr.length; i++) {
          let paramArr = urlParamArr[i].split("="); //将参数键，值拆开
          //如果键雨要删除的不一致，则加入到参数中
          if (paramArr[0] != paramKey) {
            arr.push(urlParamArr[i]);
          }
        }
      }
      if (arr.length > 0) {
        nextUrl = "?" + arr.join("&");
      }
      url = beforeUrl + nextUrl;
      return url;
    }
  }
}
